import ApiBase from '../../../features/shared/services/ApiBase';
import {http} from '../../../features/shared/services';

export default class AuthenticationApi extends ApiBase {
  logIn(model) {
    return http.post('log_in', model);
  }

  logOut() {
    return this.http.delete('logout');
  }
}



// WEBPACK FOOTER //
// ./app/features/authentication/services/AuthenticationApi.js